import { GeneralStatistics } from './GeneralStatistics/GeneralStatistics';
import { Chart } from './Chart';
import { DetectCodeStatistics } from './DetectCodeStatistics/DetectCodeStatistics';

export {
  GeneralStatistics,
  Chart,
  DetectCodeStatistics,
};
